import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    return this.isAuth(state);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    return this.isAuth(state);
  }

  private isAuth( state: RouterStateSnapshot) {

    const tokenData = localStorage.getItem('token');
    
    if(!tokenData) {
      this.router.navigate(['/', 'auth']);
      return false;
    }
    
    const token = JSON.parse(tokenData);
    
    if(token.company_id !== null && state.url.indexOf('/recruiter') === -1) {
      this.router.navigate(['/', 'recruiter']);
      return false;
    }

    return true;

  }
  
}
